/**
 * Observes elements for visibility (HandleIntersection).
 *
 * Handlers are kept per **element**, not per DOM id. Inside a repeat every row carries the same
 * id `LE_<ID>`: keyed by id, only the first row was observed and every other inner repeat with
 * HandleIntersection stayed empty forever (measured: 20 of 140 units drawn), and unobserving one
 * row removed the handler of all others. A WeakMap also lets the browser drop entries of
 * elements that are gone.
 */
export class IntersectionHelper {
    private static Observer: IntersectionObserver;

    private static Handlers = new WeakMap<Element, { handler: (visible: boolean) => void, isIntersecting?: boolean }>();

    public static Observe(element: Element, handler: (visible: boolean) => void) {
        if (!IntersectionHelper.Observer) {
            IntersectionHelper.Observer = new IntersectionObserver((entries) => {
                entries.forEach(entry => {
                    const eintrag = IntersectionHelper.Handlers.get(entry.target);
                    if (eintrag && eintrag.isIntersecting !== entry.isIntersecting) {
                        eintrag.isIntersecting = entry.isIntersecting;
                        eintrag.handler(entry.isIntersecting);
                    }
                });
            });
        }
        if (!IntersectionHelper.Handlers.has(element)) {
            IntersectionHelper.Handlers.set(element, { handler: handler });
            IntersectionHelper.Observer.observe(element);
        }
    }

    public static Unobserve(element: Element) {
        IntersectionHelper.Handlers.delete(element);
        if (IntersectionHelper.Observer) {
            IntersectionHelper.Observer.unobserve(element);
        }
    }
}
